import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";
import { NAV } from "@/lib/content";

export function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#07080B]" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo size="h-20" />
            <p className="mt-6 max-w-sm text-sm text-[var(--txt-2)] font-light leading-relaxed">
              Holding d'acquisition et de développement d'entreprises de la communication visuelle et des métiers
              techniques complémentaires en France et en Suisse.
            </p>
            <p className="mt-6 font-serif text-xl text-chrome">
              Des savoir-faire complémentaires.<br />La force d'un groupe.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-5">Navigation</div>
            <ul className="space-y-2.5">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-sm text-slate-300 hover:text-gold transition-colors">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-5">Contact confidentiel</div>
            <a href="mailto:contact@losta.group" className="text-sm text-slate-300 hover:text-gold transition-colors">
              contact@losta.group
            </a>
            <p className="mt-4 text-sm text-[var(--txt-2)]">France 🇫🇷 &nbsp;·&nbsp; Suisse 🇨🇭</p>
            <p className="mt-1 text-xs text-[var(--txt-2)]">Acquisition · Transmission · Développement</p>
            <div className="mt-8 flex flex-wrap gap-4 text-xs text-slate-500">
              <Link to="/mentions-legales" className="hover:text-gold transition-colors">Mentions légales</Link>
              <Link to="/confidentialite" className="hover:text-gold transition-colors">Confidentialité</Link>
              <Link to="/admin/login" className="hover:text-gold transition-colors">Espace confidentiel</Link>
            </div>
          </div>
        </div>

        <div className="hr-gold mt-14 mb-8 opacity-50" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Losta Group — Tous droits réservés.</p>
          <p className="font-mono tracking-widest text-slate-600">ACQUÉRIR · FÉDÉRER · DÉVELOPPER · PÉRENNISER</p>
        </div>
      </div>
    </footer>
  );
}
